import { render, staticRenderFns } from "./CompanyManagementDialog.vue?vue&type=template&id=64188aa6"
import script from "./CompanyManagementDialog.vue?vue&type=script&lang=js"
export * from "./CompanyManagementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports